import LiveStatsSummaryList from './List';

const LiveStatsSummary = {
  LiveStatsSummaryList, 
};

export default LiveStatsSummary;